<div>
  <app-breadcrumb></app-breadcrumb>
</div>

<mat-card>
  @if(!isEditMode){
    <h1 class="title">Gestion des utilisateurs - Créer un utilisateur</h1>
  } @else{
    <h1 class="title">Gestion des utilisateurs - Consulter / Modifier un utilisateur</h1>
  }

  <mat-card-content>
    <h2>Informations Utilisateur</h2>
    
    <mat-divider></mat-divider>

    <form [formGroup]="userForm">

      <div class="entite-section">
          <label>Entité<span class="required-star">*</span> :</label>
          <mat-form-field appearance="outline">
              <input type="text"
              placeholder="Entité*"
              matInput
              formControlName="entite"
              [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn">
              @for (entity of filteredEntities | async; track entity) {
                  <mat-option [value]="entity">
                      {{entity.libelle}} ({{getInterneExterneLabel(entity.interne)}})
                  </mat-option>
                  }
              </mat-autocomplete>
          </mat-form-field>
      </div>
      @if(isEntiteInterne()){
          <div class="kiwinet-section">
              <label>Compte rattaché au compte KIWINET ?</label>
              <mat-checkbox formControlName="kiwinet" color="primary"></mat-checkbox>
          </div>
      }

      <div class="nom-section">
          <label>Nom<span class="required-star">*</span> :</label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="Nom*" formControlName="nom">
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>
      </div>

      <div class="prenom-section">
          <label>Prénom<span class="required-star">*</span> :</label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="Prénom*" formControlName="prenom">
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>
      </div>

      <div class="email-section">
          <label>Adresse E-mail<span class="required-star">*</span> :</label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="Adresse E-mail*" formControlName="email">
            <mat-icon matPrefix>mail</mat-icon>
            @if(userForm.get('email')?.errors?.['emailExists']){
              <mat-error>
                Profil(s) OPUS liée à cette adresse mail existe déjà
              </mat-error>
            } @else if (userForm.get('email')?.touched && userForm.get('email')?.hasError('email')) {
              <mat-error>
                  Veuillez saisir une adresse e-mail valide.
              </mat-error>
            }
          </mat-form-field>
          @if(userForm.get('email')?.errors?.['emailExists']) {
            <button mat-raised-button (click)="redirectToEditUser()" class="edit-user-button">
              Afficher utilisateur
            </button>
          }
      </div>

      <div class="telephone-section">
          <label>N° Téléphone<span class="required-star">*</span> :</label>
          <mat-form-field appearance="outline">
            <input matInput placeholder="N° Téléphone*" formControlName="telephone">
            <mat-icon matPrefix>smartphone</mat-icon>
            @if(userForm.get('telephone')?.touched && userForm.get('telephone')?.hasError('pattern')) {
              <mat-error>
                  Veuillez saisir un numéro de téléphone valide.
              </mat-error>
            }
          </mat-form-field>
      </div>

      <mat-divider></mat-divider>

      <div class="profile-card">
          <h2>Entité & Profil</h2>
          <mat-divider></mat-divider>
          <div class="profile-section">
              <h3>Profil(s) par Entité d'accès<span class="required-star">*</span> :</h3>
              <div class="button-and-error-container">
                  <button mat-raised-button class="add-profile-button" [ngClass]="{'error-border': isSelectionsEmpty}" (click)="ouvrirDialogueAjouterProfil()"><mat-icon>add_box</mat-icon>Ajouter un profil</button>
                  @if(isSelectionsEmpty){
                      <div class="error-message">
                          Veuillez sélectionner au moins un profil.
                      </div>
                  }
              </div>
          </div>
          <div *ngFor="let entite of groupSelectionsByEntity()">
              <div class="entiteProfil-section">
                  <p>Entité : {{ entite.entiteLibelle }} - Profils: {{ entite.profils }}</p>
                  <mat-icon class="delete-icon" (click)="removeEntityProfils(entite.entiteId)">cancel</mat-icon>
                  <mat-icon class="edit-icon" (click)="ouvrirDialogueModifierProfil(entite.entiteId)">edit</mat-icon>
              </div>
          </div>
      </div>

      <mat-divider></mat-divider>

      <div class="obligatory-message">
          <p>Les champs suivis d'un <span class="required-star">*</span> sont obligatoires.</p>
      </div>
      <div class="actions">
          <button mat-raised-button (click)="redirectToUserList()">RETOUR</button>
          <div class="align">
              <button mat-raised-button (click)="redirectToUserList()">ANNULER</button>
              @if(isEditMode){
                  <button mat-raised-button class="button-delete" >SUPPRIMER</button>
              }
              <button mat-raised-button class="button-validate" (click)="onSubmit()">VALIDER</button>
          </div>
      </div>
  </form>
  </mat-card-content>
</mat-card>